'use strict';

/**
 * Lead
 *
 * @author Mathias Hayoz <mathias.hayoz@namics.com>
 */
T.Module.Lead = T.createModule({

	_selectors: {
		content: '[data-js-a-lead-content]',
		moreContent: '[data-js-a-lead-more-content]',
		iconMore: '[data-js-a-lead-icon-more]',
		ellipses: '[data-js-a-lead-ellipses]'
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		this.$content = this.$ctx.find(this._selectors.content);
		this.$moreContent = this.$ctx.find(this._selectors.moreContent);
		this.$iconMore = this.$ctx.find(this._selectors.iconMore);
		this.$ellipses = this.$ctx.find(this._selectors.ellipses);

		this.charLimit = {
			small: 180,
			large: 220
		};

		this.currentCharLimit = this.charLimit.large;

		this._events.on('viewport.setup', this.onViewportSetup.bind(this));
		this._events.on('t.sync', this.sync.bind(this));

		resolve();
	},
	sync: function sync() {
		var content = this.$ctx.find(this._selectors.content).html();

		if (content.length > this.currentCharLimit) {
			var less = content.substr(0, this.currentCharLimit);
			var more = content.substr(this.currentCharLimit, content.length - this.currentCharLimit);

			var lastSpaceIndex = less.lastIndexOf(' ');

			// check if last char is in the middle of a word and find last space
			if (lastSpaceIndex <= less.length - 1) {
				less = less.substring(0, lastSpaceIndex);
				more = content.substr(lastSpaceIndex, content.length - lastSpaceIndex);
			}

			this.$iconMore.show();
			this.$ellipses.show();

			this.$content.html(less);
			this.$moreContent.html(more);
		}

		this.$iconMore.click(this.handleClick.bind(this));
	},
	handleClick: function handleClick(event) {
		event.preventDefault();

		this.$moreContent.toggle();
		this.$iconMore.toggle();
		this.$ellipses.toggle();
	},
	onViewportSetup: function onViewportSetup(wpName) {
		switch (wpName) {
			case 'small-down':
				this.currentCharLimit = this.charLimit.small;
				break;
			default:
				this.currentCharLimit = this.charLimit.large;
				break;
		}
	}
});